import React from "react";
import portraitImage from "../assets/images/headshot.jpg";
import SocialLinks from "./SocialLinks";
import {
  aboutParagraphs,
  education,
  skillGroups,
  socialLinks,
} from "../data";

const About = () => {
  return (
    <section className="pb-8">
      <div className="grid gap-14 lg:grid-cols-[minmax(0,1fr)_20rem]">
        <div className="order-2 lg:order-1">
          <h1 className="font-display max-w-3xl text-4xl tracking-tight text-stone-900 dark:text-stone-100 sm:text-5xl">
            A little about me.
          </h1>

          <div className="mt-8 space-y-6 text-base leading-8 text-stone-600 dark:text-stone-300">
            {aboutParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>

          <section className="mt-12">
            <h2 className="text-sm font-semibold uppercase tracking-[0.22em] text-stone-500 dark:text-stone-400">
              Education
            </h2>
            <ul className="mt-5 space-y-3 text-base text-stone-700 dark:text-stone-200">
              {education.map((item) => (
                <li
                  key={item}
                  className="rounded-2xl border border-stone-200 bg-white px-5 py-4 dark:border-stone-800 dark:bg-stone-900"
                >
                  {item}
                </li>
              ))}
            </ul>
          </section>

          <section className="mt-12">
            <h2 className="text-sm font-semibold uppercase tracking-[0.22em] text-stone-500 dark:text-stone-400">
              Capabilities
            </h2>
            <div className="mt-6 grid gap-6 sm:grid-cols-2">
              {skillGroups.map((group) => (
                <div
                  key={group.title}
                  className="rounded-3xl border border-stone-200 bg-white p-6 dark:border-stone-800 dark:bg-stone-900"
                >
                  <h3 className="text-lg font-semibold text-stone-900 dark:text-stone-100">
                    {group.title}
                  </h3>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {group.items.map((item) => (
                      <span
                        key={item}
                        className="rounded-full bg-stone-100 px-3 py-2 text-sm text-stone-600 dark:bg-stone-800 dark:text-stone-300"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        <aside className="order-1 lg:order-2">
          <div className="rounded-[2rem] border border-stone-200 bg-white p-4 shadow-[0_18px_50px_-24px_rgba(28,25,23,0.2)] dark:border-stone-800 dark:bg-stone-900 dark:shadow-[0_18px_50px_-24px_rgba(0,0,0,0.55)]">
            <img
              src={portraitImage}
              alt="Obinna Okwuolisa"
              className="aspect-[4/5] w-full rotate-2 rounded-[1.6rem] object-cover"
            />
          </div>

          <div className="mt-8 rounded-3xl border border-stone-200 bg-white p-6 dark:border-stone-800 dark:bg-stone-900">
            <h2 className="text-sm font-semibold uppercase tracking-[0.22em] text-stone-500 dark:text-stone-400">
              Contact
            </h2>
            <div className="mt-5">
              <SocialLinks links={socialLinks} stacked />
            </div>
          </div>

          <div className="mt-8 rounded-3xl border border-stone-200 bg-white p-6 dark:border-stone-800 dark:bg-stone-900">
            <h2 className="text-sm font-semibold uppercase tracking-[0.22em] text-stone-500 dark:text-stone-400">
              Outside Work
            </h2>
            <p className="mt-4 text-sm leading-7 text-stone-600 dark:text-stone-300">
              Chess is one of my favorite ways to unwind and think strategically
              outside engineering.
            </p>
            <a
              href="https://www.chess.com/member/obinnaprime"
              target="_blank"
              rel="noreferrer"
              className="mt-5 inline-flex items-center rounded-full border border-stone-200 px-4 py-2 text-sm font-medium text-stone-700 transition hover:border-stone-300 hover:text-stone-950 dark:border-stone-700 dark:text-stone-200 dark:hover:border-stone-600 dark:hover:text-stone-50"
            >
              View chess profile
            </a>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default About;
